import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// Errors
import NotFoundPage from "../pages/Error/NotFoundPage";
import AccessDeniedPage from "../pages/Error/AccessDeniedPage";

// Auth
import { SignInPage, SignUpPage, ForgotPasswordPage } from "../pages/Auth";
import ProtectedRoute from "./ProtectedRoute";

import MainPage from "../pages/MainPage";
import CampaignStratergy from "../pages/components/CampaignStratergy";
import CampaignReview from "../pages/components/CampaignReview";
import CampaignListPage from "../pages/components/CampaignListPage";
import CampaignDetails from "../pages/components/CampaignDetails";
import AdsPowerManager from "../pages/AdsPower/AdsPowerManager";
import DashboardPage from "../pages/components/DashboardPage";
import AdminDashboardPage from "../pages/Admin/AdminDashboardPage";
import AdminUsersPage from "../pages/Admin/AdminUsersPage";
import AdminLogsPage from "../pages/Admin/AdminLogsPage";
import AdminCampaignsPage from "../pages/Admin/AdminCampaignsPage";
import AdminTestSendPage from "../pages/Admin/AdminTestSendPage";
import AdminSalesforceSendMethodPage from "../pages/Admin/AdminSalesforceSendMethodPage";
import UserSettingsPage from "../pages/Settings/UserSettingsPage";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* 🔓 Public — authentication */}
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      {/* 🔒 Protected — admin-only */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute adminOnly>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/logs"
        element={
          <ProtectedRoute adminOnly>
            <AdminLogsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/campaigns"
        element={
          <ProtectedRoute adminOnly>
            <AdminCampaignsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/test-send"
        element={
          <ProtectedRoute adminOnly>
            <AdminTestSendPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/salesforce-send-method"
        element={
          <ProtectedRoute adminOnly>
            <AdminSalesforceSendMethodPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/adspower"
        element={
          <ProtectedRoute adminOnly>
            <AdsPowerManager />
          </ProtectedRoute>
        }
      />

      {/* 🔒 Protected — regular user app. Admin is confined to /admin/* —
          it never creates campaigns or touches user-facing operational
          pages, it only gets a read-only overview inside the admin shell. */}
      <Route
        path="/"
        element={
          <ProtectedRoute blockAdmin>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audience"
        element={
          <ProtectedRoute blockAdmin>
            <MainPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaigns"
        element={
          <ProtectedRoute blockAdmin>
            <CampaignListPage />
          </ProtectedRoute>
        }
      />
      {/*<Route
        path="/campaign-strategy/:id"
        element={
          <ProtectedRoute blockAdmin>
            <CampaignStratergy />
          </ProtectedRoute>
        }
      />*/}
      {/* Admin exception: this is a read-only leads/email breakdown, not a
          creation/operational page — the Admin Campaigns page links here
          for its "Details" button, so it must stay reachable by admins. */}
      <Route
        path="/campaign-details/:id"
        element={
          <ProtectedRoute>
            <CampaignDetails />
          </ProtectedRoute>
        }
      />
      {/*<Route
        path="/campaign-review/:id"
        element={
          <ProtectedRoute blockAdmin>
            <CampaignReview />
          </ProtectedRoute>
        }
      />*/}
      <Route
        path="/settings"
        element={
          <ProtectedRoute blockAdmin>
            <UserSettingsPage />
          </ProtectedRoute>
        }
      />

      {/* Misc */}
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;
